import { FETCHING_PHISHING_REPORTS, FETCHING_SCAN_REPORT, PHISHING_REPORTS_FETCHED, SCAN_REPORT_FETCHED, DELETING_PHISHING_REPORT, PHISHING_REPORT_DELETED } from '../actions/';

const initState = { loading: true, response: null, list: [], pagination: null, scanReports: [], deleteResponse: null };

export default function (state = initState, action) {
	switch (action.type) {
		case FETCHING_PHISHING_REPORTS:
			return { ...state, response: null, loading: true };
		case PHISHING_REPORTS_FETCHED: {
			const payload = action.payload;
			if (payload && !payload.error && payload.data) {
				return {
					...state,
					response: payload,
					list: payload.data.data || [],
					pagination: {
						total: payload.data.total || 0,
						page: payload.data.page || 1,
						limit: payload.data.limit || 10,
						totalPages: payload.data.totalPages || 1,
					},
					loading: false,
				};
			}
			return { ...state, response: payload, list: [], pagination: null, loading: false };
		}

		case FETCHING_SCAN_REPORT:
			return { ...state, response: null, scanReports: [], fetchingScanReport: true };
		case SCAN_REPORT_FETCHED:
			return { ...state, response: action.payload, scanReports: action.payload?.data || [], fetchingScanReport: false };

		case DELETING_PHISHING_REPORT:
			return { ...state, deleteResponse: null };
		case PHISHING_REPORT_DELETED:
			return { ...state, deleteResponse: action.payload };

		default:
			return state;
	}
}
